import React from "react";
import "./candidateSignUp.sass";
import FormCandidate from "./components/FormCandidate";
const CandidateSignUp = () => {
  return (
    <div className="container-form" style={{ height: "100vh", overflowY: "auto" }}>
      <div className="d-flex justify-content-center align-items-center h-100">
        <div className="container-create-account">
          <FormCandidate />
        </div>
      </div>
    </div>
  );
};

export default CandidateSignUp;
